// extracted by mini-css-extract-plugin
export default {"otpInput":"otp_otpInput__Js5XF"};